import * as React from "react";
const SensorInfoIcon = (props) => (
  <svg
    width={20}
    height={21}
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="path-1-outside-1_14147_34561"
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={20}
      height={21}
      fill="black"
    >
      <rect fill="white" width={20} height={21} />
      <path d="M0 0H20V20H0V0Z" />
    </mask>
    <path
      d="M0 20.5H0.5V19.5H0V20.5ZM1.5 20.5H2.5V19.5H1.5V20.5ZM3.5 20.5H4.5V19.5H3.5V20.5ZM5.5 20.5H6.5V19.5H5.5V20.5ZM7.5 20.5H8.5V19.5H7.5V20.5ZM9.5 20.5H10.5V19.5H9.5V20.5ZM11.5 20.5H12.5V19.5H11.5V20.5ZM13.5 20.5H14.5V19.5H13.5V20.5ZM15.5 20.5H16.5V19.5H15.5V20.5ZM17.5 20.5H18.5V19.5H17.5V20.5ZM19.5 20.5H20V19.5H19.5V20.5ZM0 21H0.5V19H0V21ZM1.5 21H2.5V19H1.5V21ZM3.5 21H4.5V19H3.5V21ZM5.5 21H6.5V19H5.5V21ZM7.5 21H8.5V19H7.5V21ZM9.5 21H10.5V19H9.5V21ZM11.5 21H12.5V19H11.5V21ZM13.5 21H14.5V19H13.5V21ZM15.5 21H16.5V19H15.5V21ZM17.5 21H18.5V19H17.5V21ZM19.5 21H20V19H19.5V21Z"
      fill="currentColor"
      mask="url(#path-1-outside-1_14147_34561)"
    />
    <path
      d="M6.46663 13.5333C5.55829 12.6333 4.99996 11.3833 4.99996 10C4.99996 8.61667 5.55829 7.36667 6.46663 6.46667L7.64996 7.65C7.04163 8.25 6.66663 9.08334 6.66663 10C6.66663 10.9167 7.04163 11.75 7.64163 12.3583L6.46663 13.5333ZM13.5333 13.5333C14.4416 12.6333 15 11.3833 15 10C15 8.61667 14.4416 7.36667 13.5333 6.46667L12.35 7.65C12.9583 8.25 13.3333 9.08334 13.3333 10C13.3333 10.9167 12.9583 11.75 12.3583 12.3583L13.5333 13.5333ZM9.99996 8.33334C9.08329 8.33334 8.33329 9.08334 8.33329 10C8.33329 10.9167 9.08329 11.6667 9.99996 11.6667C10.9166 11.6667 11.6666 10.9167 11.6666 10C11.6666 9.08334 10.9166 8.33334 9.99996 8.33334ZM16.6666 10C16.6666 11.8417 15.9166 13.5083 14.7083 14.7083L15.8916 15.8917C17.4 14.3833 18.3333 12.3 18.3333 10C18.3333 7.7 17.4 5.61667 15.8916 4.10834L14.7083 5.29167C15.9166 6.49167 16.6666 8.15834 16.6666 10ZM5.29163 5.29167L4.10829 4.10834C2.59996 5.61667 1.66663 7.7 1.66663 10C1.66663 12.3 2.59996 14.3833 4.10829 15.8917L5.29163 14.7083C4.08329 13.5083 3.33329 11.8417 3.33329 10C3.33329 8.15834 4.08329 6.49167 5.29163 5.29167Z"
      fill="currentColor"
    />
  </svg>
);
export default SensorInfoIcon;
